import { Space } from "~/lib/types";
import { SpaceOrWorkspaceScope } from "~/hooks/useScope";
import { SpaceVulnerabilityPage } from "~/pages/space/vulnerabilities/SpaceVulnerability";

interface CveEntryPageProps {
  space: Space;
  scope: SpaceOrWorkspaceScope;
}

const CveEntryPage = ({ space, scope }: CveEntryPageProps) => {
  return <SpaceVulnerabilityPage space={space} scope={scope} />;
};

export default CveEntryPage;
